import type { initTabTotal } from '../../state/initTabTotal';

export type TabTotalComponentType = { initTabTotal?: typeof initTabTotal };
export type TabTotalReactElementLike = { type: TabTotalComponentType };
